import { render, staticRenderFns } from "./panel_waitTake.vue?vue&type=template&id=9b7a0d5e&scoped=true&"
import script from "./panel_waitTake.vue?vue&type=script&lang=js&"
export * from "./panel_waitTake.vue?vue&type=script&lang=js&"
import style0 from "./panel_waitTake.vue?vue&type=style&index=0&id=9b7a0d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7a0d5e",
  null
  
)

export default component.exports